/* eslint-disable jsx-a11y/anchor-is-valid */
import 'components/BusinessArticles/index.scss';

import { Image, Row } from 'react-bootstrap';

// import { ARTICLES } from 'navigation/constants';
import { IMAGES } from 'common/images';

export const BusinessArticles = () => (
  <Row className="justify-content-center business-articles">
    <a href="#" rel="noopener">
      <Image className="business-articles__img" src={IMAGES.BS} alt="business-standard" />
    </a>
    <a href="#" rel="noopener">
      <Image className="business-articles__img" src={IMAGES.BW} alt="business-world" />
    </a>
    <a href="#" rel="noopener">
      <Image className="business-articles__img__bfsi" src={IMAGES.BFSI} alt="bfsi" />
    </a>
  </Row>
);
